import BaseObjectStore from './base-object.store';

class HydrationFormStore extends BaseObjectStore {
  constructor(props) {
    super(props);
    this.name = 'hydrationForm';
  }

  resetAllFields() {
    this.resetAllBaseFields();
  }
}

export default new HydrationFormStore();
